import React from 'react'
import { AppBar, Hidden, Icon, makeStyles, Divider } from '@material-ui/core'
import { FuseScrollbars } from '@fuse'
import clsx from 'clsx'
import Logo from 'app/fuse-layouts/shared-components/Logo'
import NavbarFoldedToggleButton from 'app/fuse-layouts/shared-components/NavbarFoldedToggleButton'
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton'
import Navigation from 'app/fuse-layouts/shared-components/Navigation'
import ServicePolicy from 'app/components/ServicePolicy'
import Assets from 'app/configs/assetConfigs'

import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.palette.primary.background,
    width: 300,
  },
  content: {
    overflowX: 'hidden',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 40px, 100% 10px',
    backgroundAttachment: 'local, scroll',
  },
  fontSize: {
    fontSize: '16px',
    color: theme.palette.grey.morevertIcon + ' !important',
  },
  link: {
    fontSize: '13px !important',
    cursor: 'pointer',
    color: theme.palette.grey.morevertIcon + ' !important',
  },
  copyright: {
    color: theme.palette.grey.morevertIcon + ' !important',
  },
  iconBlack: {
    color: '#000',
  },
  rtlStyle: {
    '&& .list-item-text': {
      textAlign: 'initial !important',
    },
    '&& .list-item-icon': {
      paddingLeft: '1.6rem !important',
      paddingRight: '1.6rem !important',
    },
    '&& .list-item-img': {
      paddingRight: '1.6rem !important',
    },
  },
  messageSpringLogo: {
    width: '12%',
  },
}))

function NavbarLayoutMain(props) {
  const classes = useStyles()
  const direction = useSelector(({ fuse }) => fuse.settings.defaults.direction)

  return (
    <div
      className={clsx(
        'flex flex-col overflow-hidden h-full',
        classes.appBar,
        props.className,
      )}
    >
      <AppBar
        position="static"
        elevation={0}
        className={clsx(
          classes.appBar,
          'py-12 flex flex-row items-start justify-between min-h-64 flex-shrink-0 ltr:pl-20 rtl:pr-20 ltr:pr-12 rtl:pl-12',
          'appBar',
        )}
      >
        {props.foldedAndOpened || !props.folded ? (
          <Logo />
        ) : (
          <img
            src={Assets.logo}
            alt="messageSpringLogo"
            className={clsx('m-1', classes.messageSpringLogo)}
          />
        )}

        <Hidden mdDown>
          <NavbarFoldedToggleButton className="w-40 h-40 p-0" />
        </Hidden>

        <Hidden lgUp>
          <NavbarMobileToggleButton
            className={clsx(classes.iconBlack, 'w-40 h-40 p-0')}
          >
            <Icon>menu</Icon>
          </NavbarMobileToggleButton>
        </Hidden>
      </AppBar>

      <FuseScrollbars className={clsx(classes.content)}>
        <Navigation
          layout="vertical"
          className={direction === 'rtl' && classes.rtlStyle}
        />
        {!props.folded || props.foldedAndOpened ? (
          <>
            <Divider className="my-5" />
            <ServicePolicy />
          </>
        ) : (
          ''
        )}
      </FuseScrollbars>
    </div>
  )
}

export default NavbarLayoutMain
